import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../ServicePage.css';

function SviluppoWebFrontend() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const technologies = [
        "React.js & Next.js",
        "Vue.js & Nuxt.js", 
        "Angular & TypeScript",
        "HTML5, CSS3, SASS/SCSS",
        "JavaScript ES6+",
        "Responsive Design",
        "Bootstrap & Tailwind CSS",
        "Progressive Web Apps (PWA)"
    ];

    const features = [
        "Single Page Applications (SPA)",
        "Server Side Rendering (SSR)",
        "Static Site Generation (SSG)",
        "Component-based architecture",
        "State management (Redux, Vuex)",
        "API integration (REST, GraphQL)",
        "Performance optimization",
        "Cross-browser compatibility"
    ];

    const tools = [
        "Webpack & Vite",
        "ESLint & Prettier",
        "Jest & Cypress testing",
        "Git version control",
        "NPM/Yarn package management",
        "Chrome DevTools",
        "Figma to code conversion",
        "CI/CD pipeline setup"
    ];

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Sviluppo Web Frontend</h1>
                    <p className="service-description">
                        Interfacce utente moderne e responsive con React, Vue.js e tecnologie 
                        all'avanguardia per un'esperienza utente ottimale su ogni dispositivo.
                    </p>
                </div>

                <Row className="mb-5">
                        <Col lg={8}>
                            <div className="service-description">
                                <h3>Sviluppo Frontend Professionale</h3>
                                <p>
                                    Creo interfacce web moderne, responsive e performanti utilizzando le più 
                                    recenti tecnologie frontend. Dal design system alla implementazione completa,
                                    garantisco un'esperienza utente eccellente e codice maintainible.
                                </p>
                                <p>
                                    Specializzato in React.js, Vue.js e architetture moderne, sviluppo 
                                    applicazioni web scalabili con focus su performance, accessibilità 
                                    e user experience ottimale.
                                </p>
                            </div>

                            <div className="technologies-section">
                                <h3>Tecnologie Frontend</h3>
                                <Row>
                                    {technologies.map((tech, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🎨</span>
                                                {tech}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="features-section">
                                <h3>Funzionalità Avanzate</h3>
                                <Row>
                                    {features.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">⚡</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <Alert variant="info" className="frontend-alert">
                                <h5><i className="fas fa-rocket"></i> Performance Optimization</h5>
                                <p>
                                    Ottimizzazione avanzata delle performance con code splitting, lazy loading,
                                    image optimization e best practices per Core Web Vitals e SEO.
                                </p>
                            </Alert>

                            <div className="tools-section">
                                <h3>Tools e Workflow</h3>
                                <Row>
                                    {tools.map((tool, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🛠️</span>
                                                {tool}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="service-process">
                                <h3>Processo di Sviluppo</h3>
                                <div className="process-steps">
                                    <div className="process-step-item">
                                        <div className="step-number">1</div>
                                        <div className="step-text">Analisi requirements e design system</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">2</div>
                                        <div className="step-text">Setup architettura e componenti base</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">3</div>
                                        <div className="step-text">Sviluppo iterativo con testing continuo</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">4</div>
                                        <div className="step-text">Ottimizzazione performance e deployment</div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="service-sidebar">
                                <Card className="service-info-card">
                                    <Card.Body>
                                        <h4>Specializzazioni Frontend</h4>
                                        <ul>
                                            <li>React.js & Redux/Context</li>
                                            <li>Vue.js & Vuex/Pinia</li>
                                            <li>TypeScript development</li>
                                            <li>Mobile-first responsive</li>
                                            <li>PWA implementation</li>
                                            <li>Micro-frontends</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="ui-frameworks-card">
                                    <Card.Body>
                                        <h4>🎨 UI Frameworks</h4>
                                        <ul>
                                            <li>Material-UI / MUI</li>
                                            <li>Ant Design</li>
                                            <li>Chakra UI</li>
                                            <li>Bootstrap 5</li>
                                            <li>Tailwind CSS</li>
                                            <li>Styled Components</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="benefits-card">
                                    <Card.Body className="text-center">
                                        <h5>💡 Vantaggi</h5>
                                        <ul style={{textAlign: 'left'}}>
                                            <li>Performance ottimali</li>
                                            <li>Codice maintainibile</li>
                                            <li>SEO-friendly</li>
                                            <li>Cross-browser support</li>
                                            <li>Accessibilità WCAG</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <div className="cta-section">
                                    <a href="#contact" className="btn-gradient w-100 mb-3">
                                        <span>Richiedi Preventivo Frontend</span>
                                    </a>
                                    <Link to="/services" className="btn btn-outline-primary w-100">
                                        Torna ai Servizi
                                    </Link>
                                </div>
                            </div>
                        </Col>
                </Row>
            </Container>
        </div>
    );
}

export default SviluppoWebFrontend;